import barba from '@barba/core';
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.bgColorScroll()
        });
        barba.hooks.after((data) => {
            this.bgColorScroll()
        });

    }
    bgColorScroll(){
        this.bg = document.querySelector('#js-bgColor');
        this.image = document.querySelector('#js-bgImage');
        this.els = document.querySelectorAll('.js-bgColor__sec');
        this.slides = document.querySelectorAll('.js-bgImage__slide');
        if(this.bg) {
            this.els.forEach(el => {
                let color = el.dataset.color;
                gsap.to(this.bg, {
                    backgroundColor: color,
                    scrollTrigger: {    
                        trigger: el,
                        start: 'top center',
                        end: 'bottom center',
                        // toggleActions: 'play pause resume restart',
                        onEnter: () => gsap.to(this.bg, {backgroundColor:color}), 
                        onLeave: () => gsap.to(this.bg, {backgroundColor:'#2F2C2B'}), 
                        onLeaveBack: () => gsap.to(this.bg, {backgroundColor:'#2DA7E8'}), 
                        onEnterBack: () => gsap.to(this.bg, {backgroundColor:color}), 
                    }
                })
            })
        }
        if(this.image) {
            this.els.forEach( (el, i) => {
                gsap.to(this.slides[i], {
                    scrollTrigger: {    
                        trigger: el,
                        start: 'top center',
                        end: 'bottom center',
                        // toggleActions: 'play pause resume restart',
                        onEnter: () => this.slides[i].classList.add('is-active'), 
                        onLeave: () => this.slides[i].classList.add('is-active'), 
                        onLeaveBack: () => this.slides[i].classList.remove('is-active'), 
                        onEnterBack: () => this.slides[i].classList.add('is-active'), 
                    }
                })
            })
        }
    }
}